export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)

  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  // Совпадение проверяется по границе сегмента, а не подстрокой: `indexOf` считал
  // «Кассы» (`/settings/cashboxes`) активным и на `/settings/cashboxes-priorities`,
  // подсвечивая в меню сразу два пункта. Вложенные пути (`/settings/merchants/12`)
  // подсвечиваться обязаны, поэтому проверка префиксная, а не строгое равенство.
  const prefix = url.endsWith('/') ? url : `${url}/`

  return current.startsWith(prefix)
}
